<template>
  <div>
    <b-toast :id="getID" variant="danger" solid auto-hide-delay="10000" no-auto-hide append-toast no-close-button>
      <div slot="toast-title" class="d-flex flex-grow-1 align-items-baseline">
        <b-img blank blank-color="#ff5555" class="mr-2" width="12" height="12"></b-img>
        <strong class="mr-auto">Notice!</strong>
        <strong class="mr-auto">Error encountered.</strong>
        <button
          data-test-id="global-error-dialog__close"
          type="button"
          aria-label="Close"
          class="close ml-auto mb-1"
          @click="noToast(getID)"
        >
          ×
        </button>
      </div>
      {{ error }}
    </b-toast>
  </div>
</template>

<script>
import { mapActions, mapState, mapGetters } from "vuex";

export default {
  name: "Error",
  data() {
    return {
      id: -1
    };
  },
  computed: {
    getID() {
      return `toast${this.id}`;
    },
    ...mapState("Error", ["error"]),
    ...mapGetters("Error", ["isError"])
  },
  watch: {
    isError(newValue) {
      if (newValue) {
        this.makeToast();
      }
    }
  },
  methods: {
    ...mapActions("Error", ["clearError"]),
    showToast() {
      this.id += 1;
      const nextID = `toast${this.id}`;
      this.$nextTick(() => {
        this.$bvToast.show(nextID);
      });
    },
    makeToast() {
      const errorMessage = this.error;
      this.$bvToast.toast(errorMessage, {
        id: "toastError",
        autoHideDelay: 10000,
        title: "Error encountered",
        variant: "danger",
        solid: true
      });
      setTimeout(() => {
        this.clearError();
      }, 9000);
    },
    noToast(id) {
      this.$bvToast.hide(id);
      this.clearError();
    }
  }
};
</script>
